import { VSkeletonLoader } from 'vuetify/lib/components/VSkeletonLoader';

var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(VSkeletonLoader,{attrs:{"type":"list-item-two-line"}})}
var staticRenderFns = []

export { render, staticRenderFns }